import React from "react";
import { twMerge } from "tailwind-merge";
export const SelectHeader = ({ className, children }) => {
    return (React.createElement("div", { className: twMerge("flex w-full  items-center gap-3 bg-on-main-color px-4 py-2.5 text-gray-text-color", className) },
        React.createElement("div", { className: "h-px w-full bg-separator-color" }),
        React.createElement("div", { className: "typography-small whitespace-nowrap " }, children),
        React.createElement("div", { className: "h-px w-full bg-separator-color" })));
};
//# sourceMappingURL=SelectHeader.js.map